import app from '@/main.js'

// id - message ID
async function messageSetReaction ({ senderUserId, id, reactionId }) {
  return await app.wsp.sendRequest({
    data: {
      senderUserId: senderUserId,
      id: id,
      reactionId: reactionId
    },
    method: 'message.setReaction'
  })
}

export default messageSetReaction